var _defs, _defs2, _defs3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMAndroidCardBg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "100%",
    height: "100%",
    viewBox: "0 0 5000 2916",
    style: {
      enableBackground: "new 0 0 5000 2916"
    },
    preserveAspectRatio: "none",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#003333"
    },
    width: 5000,
    height: 2916
  }), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_1_",
    points: "2800.32,2916 0,0 0,2916  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000160180510511370346470000002773904527967893141_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000115509604699691407940000002730199075389133960_",
    gradientUnits: "userSpaceOnUse",
    x1: 117.8774,
    y1: 129.0597,
    x2: 2868.3071,
    y2: 2979.5676
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF3399"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    style: {
      stopColor: "#FFFF66"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    style: {
      stopColor: "#00CCFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#CC33FF"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    style: {
      clipPath: "url(#SVGID_00000160180510511370346470000002773904527967893141_)",
      fill: "url(#SVGID_00000115509604699691407940000002730199075389133960_)"
    },
    width: 2800.32,
    height: 2916
  })), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter",
    filterUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1450.319,
    height: 2916
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1450.319,
    height: 2916,
    id: "SVGID_00000036230294778196290900000009404861156351267715_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter)"
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000034773051973617716810000018337038233419557304_",
    gradientUnits: "userSpaceOnUse",
    x1: -5743.0669,
    y1: 2183.7771,
    x2: -3672.5967,
    y2: 113.3073,
    gradientTransform: "matrix(1 0 0 1 5742.4492 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    style: {
      fill: "url(#SVGID_00000034773051973617716810000018337038233419557304_)"
    },
    width: 1450.319,
    height: 2916
  }))), /*#__PURE__*/React.createElement("polygon", {
    style: {
      mask: "url(#SVGID_00000036230294778196290900000009404861156351267715_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFFF66"
    },
    points: " 0,2916 955.471,994.94 1450.319,0 0,0  "
  }), _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000118389288925283849300000013835766115956153500_",
    filterUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 5000,
    height: 2916
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 5000,
    height: 2916,
    id: "SVGID_00000057853529256802995680000002559259097439334824_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000118389288925283849300000013835766115956153500_)"
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000049942367535699885890000000283232838085250738_",
    gradientUnits: "userSpaceOnUse",
    x1: -5326.8267,
    y1: 3369.2671,
    x2: -2316.47,
    y2: 608.9244,
    gradientTransform: "matrix(1 0 0 1 5742.4492 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    style: {
      fill: "url(#SVGID_00000049942367535699885890000000283232838085250738_)"
    },
    width: 5000,
    height: 2916
  }))), /*#__PURE__*/React.createElement("polygon", {
    style: {
      mask: "url(#SVGID_00000057853529256802995680000002559259097439334824_)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#33CC66"
    },
    points: " 1795.005,1869.155 5000,0 1450.319,0 955.471,994.94 0,2916  "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMAndroidCardBg);
export default __webpack_public_path__ + "static/media/mAndroidCardBG.8c23c52f4bc71d82bfe38b91852e14c0.svg";
export { ForwardRef as ReactComponent };